import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/personaReferencia";
import {
  PostVerificarDocumentoIntegrante,
  GetIdentificacionIntegranteExtranjero
} from "../../../reducers/personaReferencia";

export interface VerificarDocumentoIntegranteDispatcher {
  postVerificarDocumentoIntegrante: (
    idMembresiaSocioPersona: number
  ) => Promise<Preview<PostVerificarDocumentoIntegrante>>;
  getIdentificacionIntegranteExtranjero: (
    idMembresiaSocioPersona: number
  ) => Promise<Preview<GetIdentificacionIntegranteExtranjero>>;
  clearPersonaReferencia: () => void;
}

export const verificarDocumentoIntegranteDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => VerificarDocumentoIntegranteDispatcher = dispatch => ({
  postVerificarDocumentoIntegrante: (idMembresiaSocioPersona: number) =>
    dispatch(actions.postVerificarDocumentoIntegrante(idMembresiaSocioPersona)),
  getIdentificacionIntegranteExtranjero: (idMembresiaSocioPersona: number) =>
    dispatch(
      actions.getIdentificacionIntegranteExtranjero(idMembresiaSocioPersona)
    ),
  clearPersonaReferencia: () => dispatch(actions.clearPersonaReferencia())
});
